(function() {
    'use strict';

    // Initialize search functionality when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        const searchTrigger = document.querySelector('.voyapon-search-trigger');
        let searchOverlay = null;
        let searchInput = null;
        let searchResults = null;
        let searchTimer = null;
        let currentRequest = null;
        
        // Keyboard shortcuts
        document.addEventListener('keydown', function(e) {
            // Skip if user is typing in an input, textarea, or contenteditable
            const tagName = e.target.tagName.toLowerCase();
            const isEditable = e.target.getAttribute('contenteditable') === 'true';
            const isInForm = tagName === 'input' || tagName === 'textarea' || tagName === 'select';
            
            if (isInForm || isEditable) {
                return;
            }
            
            // Open search with '/' key
            if (e.key === '/' && !e.ctrlKey && !e.metaKey && !e.altKey) {
                e.preventDefault();
                openSearch();
            }
            
            // Open search with Ctrl/Cmd + K
            if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                openSearch();
            }
        });

        // Create search overlay HTML
        function createSearchOverlay() {
            const overlayHTML = `
                <div class="voyapon-search-overlay">
                    <div class="search-overlay-backdrop"></div>
                    <div class="search-overlay-content">
                        <div class="search-overlay-header">
                            <div class="container">
                                <div class="search-input-wrapper">
                                    <input type="text" 
                                           class="search-autocomplete-input" 
                                           placeholder="${voyapon_search_vars.translations.search_placeholder}" 
                                           autocomplete="off">
                                    <div class="search-shortcut-hint">
                                        <kbd>/</kbd> or <kbd>Ctrl+K</kbd>
                                    </div>
                                    <button class="search-close-btn" aria-label="${voyapon_search_vars.translations.close_search}">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div class="search-filters">
                                    <label class="search-filter-item">
                                        <input type="checkbox" name="search-filter" value="spots" checked>
                                        <span>${voyapon_search_vars.translations.spots}</span>
                                    </label>
                                    <label class="search-filter-item">
                                        <input type="checkbox" name="search-filter" value="destinations" checked>
                                        <span>${voyapon_search_vars.translations.destinations}</span>
                                    </label>
                                    <label class="search-filter-item">
                                        <input type="checkbox" name="search-filter" value="posts" checked>
                                        <span>${voyapon_search_vars.translations.posts}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="search-results-wrapper">
                            <div class="container">
                                <div class="search-results-content">
                                    <div class="search-loading" style="display: none;">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">${voyapon_search_vars.translations.loading}</span>
                                        </div>
                                    </div>
                                    <div class="search-results-list"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            
            document.body.insertAdjacentHTML('beforeend', overlayHTML);
            searchOverlay = document.querySelector('.voyapon-search-overlay');
            searchInput = document.querySelector('.search-autocomplete-input');
            searchResults = document.querySelector('.search-results-list');
        }

        // Open search overlay
        function openSearch() {
            if (!searchOverlay) {
                createSearchOverlay();
                bindSearchEvents();
            }
            
            searchOverlay.classList.add('active');
            document.body.classList.add('search-overlay-open');
            
            // Focus input after animation
            setTimeout(function() {
                searchInput.focus();
            }, 300);
        }

        // Close search overlay
        function closeSearch() {
            if (searchOverlay) {
                searchOverlay.classList.remove('active');
                document.body.classList.remove('search-overlay-open');
                searchInput.value = '';
                searchResults.innerHTML = '';
                
                // Cancel any pending requests
                if (currentRequest && currentRequest.readyState !== 4) {
                    currentRequest.abort();
                }
            }
        }

        // Perform search
        function performSearch(query) {
            if (query.length < 2) {
                searchResults.innerHTML = '';
                return;
            }

            // Show loading
            const searchLoading = document.querySelector('.search-loading');
            searchLoading.style.display = 'block';
            searchResults.innerHTML = '';

            // Cancel previous request if still pending
            if (currentRequest && currentRequest.readyState !== 4) {
                currentRequest.abort();
            }

            // Get active filters
            const activeFilters = [];
            document.querySelectorAll('input[name="search-filter"]:checked').forEach(function(checkbox) {
                activeFilters.push(checkbox.value);
            });

            // Prepare form data for AJAX request
            const formData = new FormData();
            formData.append('action', 'voyapon_ajax_search');
            formData.append('nonce', voyapon_search_vars.nonce);
            formData.append('query', query);
            activeFilters.forEach(filter => {
                formData.append('filters[]', filter);
            });

            // Perform AJAX search using XMLHttpRequest
            currentRequest = new XMLHttpRequest();
            currentRequest.open('POST', voyapon_search_vars.ajax_url, true);
            
            currentRequest.onload = function() {
                searchLoading.style.display = 'none';
                
                if (currentRequest.status === 200) {
                    try {
                        const response = JSON.parse(currentRequest.responseText);
                        if (response.success && response.data) {
                            displayResults(response.data);
                        } else {
                            displayNoResults();
                        }
                    } catch (e) {
                        displayError();
                    }
                } else {
                    displayError();
                }
            };
            
            currentRequest.onerror = function() {
                searchLoading.style.display = 'none';
                displayError();
            };
            
            currentRequest.send(formData);
        }

        // Display search results
        function displayResults(data) {
            searchResults.innerHTML = '';
            
            // Display posts
            if (data.posts && data.posts.length > 0) {
                const postsSection = document.createElement('div');
                postsSection.className = 'search-section';
                postsSection.innerHTML = `<h3 class="search-section-title">${voyapon_search_vars.translations.posts}</h3>`;
                
                const postsList = document.createElement('ul');
                postsList.className = 'search-items-list';
                
                data.posts.forEach(function(post) {
                    const postItem = document.createElement('li');
                    postItem.className = 'search-item';
                    postItem.innerHTML = `
                        <a href="${post.url}" class="search-item-link">
                            ${post.thumbnail ? `<div class="search-item-thumbnail">
                                <img src="${post.thumbnail}" alt="${post.title}">
                            </div>` : ''}
                            <div class="search-item-content">
                                <h4 class="search-item-title">${post.title}</h4>
                                ${post.excerpt ? `<p class="search-item-excerpt">${post.excerpt}</p>` : ''}
                                <span class="search-item-meta">${post.date}</span>
                            </div>
                        </a>
                    `;
                    postsList.appendChild(postItem);
                });
                
                postsSection.appendChild(postsList);
                searchResults.appendChild(postsSection);
            }
            
            // Display categories
            if (data.categories && data.categories.length > 0) {
                const categoriesSection = document.createElement('div');
                categoriesSection.className = 'search-section';
                categoriesSection.innerHTML = `<h3 class="search-section-title">${voyapon_search_vars.translations.categories}</h3>`;
                
                const categoriesList = document.createElement('ul');
                categoriesList.className = 'search-items-list';
                
                data.categories.forEach(function(category) {
                    const categoryItem = document.createElement('li');
                    categoryItem.className = 'search-item search-item-category';
                    categoryItem.innerHTML = `
                        <a href="${category.url}" class="search-item-link">
                            <div class="search-item-content">
                                <h4 class="search-item-title">${category.name}</h4>
                                ${category.description ? `<p class="search-item-excerpt">${category.description}</p>` : ''}
                                <span class="search-item-meta">${category.count} ${category.count === 1 ? voyapon_search_vars.translations.post : voyapon_search_vars.translations.posts_plural}</span>
                            </div>
                        </a>
                    `;
                    categoriesList.appendChild(categoryItem);
                });
                
                categoriesSection.appendChild(categoriesList);
                searchResults.appendChild(categoriesSection);
            }
            
            // Display spots
            if (data.spots && data.spots.length > 0) {
                const spotsSection = document.createElement('div');
                spotsSection.className = 'search-section';
                spotsSection.innerHTML = `<h3 class="search-section-title">${voyapon_search_vars.translations.spots}</h3>`;
                
                const spotsList = document.createElement('ul');
                spotsList.className = 'search-items-list';
                
                data.spots.forEach(function(spot) {
                    const spotItem = document.createElement('li');
                    spotItem.className = 'search-item search-item-spot';
                    spotItem.innerHTML = `
                        <a href="${spot.url}" class="search-item-link">
                            <div class="search-item-content">
                                <h4 class="search-item-title">${spot.name}</h4>
                                ${spot.address ? `<p class="search-item-address">${spot.address}</p>` : ''}
                                ${spot.summary ? `<p class="search-item-excerpt">${spot.summary}</p>` : ''}
                                <div class="search-item-meta">
                                    ${spot.type ? `<span class="spot-type">${spot.type}</span>` : ''}
                                    ${spot.rating ? `<span class="spot-rating">★ ${spot.rating}</span>` : ''}
                                </div>
                            </div>
                        </a>
                    `;
                    spotsList.appendChild(spotItem);
                });
                
                spotsSection.appendChild(spotsList);
                searchResults.appendChild(spotsSection);
            }
            
            // Show no results if all are empty
            if ((!data.posts || data.posts.length === 0) && 
                (!data.categories || data.categories.length === 0) && 
                (!data.spots || data.spots.length === 0)) {
                displayNoResults();
            }
        }

        // Display no results message
        function displayNoResults() {
            searchResults.innerHTML = `
                <div class="search-no-results">
                    <p>${voyapon_search_vars.translations.no_results}</p>
                </div>
            `;
        }

        // Display error message
        function displayError() {
            searchResults.innerHTML = `
                <div class="search-error">
                    <p>${voyapon_search_vars.translations.error_message}</p>
                </div>
            `;
        }

        // Bind search events
        function bindSearchEvents() {
            // Close on backdrop click
            const backdrop = document.querySelector('.search-overlay-backdrop');
            backdrop.addEventListener('click', closeSearch);
            
            // Close on close button click
            const closeBtn = document.querySelector('.search-close-btn');
            closeBtn.addEventListener('click', closeSearch);
            
            // Close on ESC key
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('active')) {
                    closeSearch();
                }
            });
            
            // Search on input with debouncing
            searchInput.addEventListener('input', function() {
                const query = this.value.trim();
                
                clearTimeout(searchTimer);
                searchTimer = setTimeout(function() {
                    performSearch(query);
                }, 300); // 300ms debounce
            });
            
            // Re-perform search when filters change
            document.addEventListener('change', function(e) {
                if (e.target.matches('input[name="search-filter"]')) {
                    const query = searchInput.value.trim();
                    if (query.length >= 2) {
                        performSearch(query);
                    }
                }
            });
            
            // Prevent form submission on enter
            searchInput.addEventListener('keypress', function(e) {
                if (e.which === 13 || e.keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        // Bind click event to search trigger
        if (searchTrigger) {
            searchTrigger.addEventListener('click', function(e) {
                e.preventDefault();
                openSearch();
            });
        }
    });
})();